import e from "./index104.js";
import { tokens as t } from "./index325.js";
//#region src/theme/blablacar/theme.ts
var n = ({ ...t }) => e({
	...t,
	shape: { borderRadius: 16 },
	palette: {
		primary: {
			main: t.color.neutral.txt.default,
			light: t.color.neutral.txt.weak,
			contrastText: t.color.neutral.txt.inverted
		},
		secondary: {
			main: t.color.accent.txt.default,
			contrastText: t.color.accent.txt.inverted,
			dark: t.color.accent.txt.defaultActive
		},
		background: {
			default: t.color.neutral.bg.default,
			paper: t.color.neutral.bg.default
		},
		warning: { main: t.color.warning.txt.default },
		success: {
			main: t.color.success.txt.default,
			contrastText: t.color.success.txt.inverted,
			light: t.color.success.bg.weak
		},
		error: { main: t.color.danger.txt.default }
	},
	typography: { fontFamily: t.typo.fontFamily },
	components: {
		MuiTooltip: {
			defaultProps: {
				placement: "top",
				arrow: !0,
				slotProps: { popper: { modifiers: [{
					name: "offset",
					options: { offset: [0, -6] }
				}] } }
			},
			styleOverrides: {
				tooltip: {
					backgroundColor: t.color.neutral.bg.strong,
					color: t.color.neutral.txt.inverted,
					borderRadius: t.radius.default,
					whiteSpace: "pre-line",
					paddingBlockStart: t.measure.spacing.vertical.default,
					paddingBlockEnd: t.measure.spacing.vertical.default,
					paddingInlineStart: t.measure.spacing.horizontal.smaller,
					paddingInlineEnd: t.measure.spacing.horizontal.smaller,
					fontSize: "16px",
					lineHeight: "20px",
					fontWeight: 400
				},
				arrow: { color: t.color.neutral.bg.strong }
			}
		},
		MuiContainer: { styleOverrides: {
			maxWidthLg: { maxWidth: "1272px!important" },
			maxWidthSm: { maxWidth: "662px!important" }
		} },
		MuiIconButton: {
			defaultProps: {
				disableFocusRipple: !0,
				disableTouchRipple: !0,
				disableRipple: !0
			},
			styleOverrides: { colorSecondary: {
				color: t.color.accent.txt.default,
				borderRadius: 0,
				backgroundColor: "transparent!important",
				transitionDuration: "200ms",
				"&:hover, &:focus-visible": { color: t.color.accent.txt.defaultActive }
			} }
		},
		MuiRadio: { styleOverrides: { root: {
			padding: 0,
			color: t.color.accent.txt.default,
			"&.Mui-checked": { color: t.color.accent.txt.default }
		} } },
		MuiInputAdornment: { styleOverrides: { root: { color: t.color.neutral.txt.moderate } } },
		SpaRadioCard: { styleOverrides: { root: { ":has(input:checked)": {
			borderColor: t.color.accent.bg.default,
			outline: `1px solid ${t.color.accent.bg.default}`
		} } } },
		MuiFormControlLabel: { styleOverrides: { root: {
			gap: t.measure.size.m,
			paddingInline: "20px",
			paddingBlock: "12px",
			marginRight: 0,
			marginLeft: 0,
			"&:hover": { backgroundColor: t.color.neutral.bg.defaultActive },
			".MuiFormControlLabel-label": { color: t.color.neutral.txt.default },
			[t.breakpoints.up("md")]: { borderRadius: t.radius.default }
		} } },
		MuiFormLabel: { styleOverrides: { root: {
			fontSize: "13px",
			lineHeight: "16px",
			color: t.color.neutral.txt.default
		} } },
		MuiInputLabel: { styleOverrides: { root: {
			...t.typo.label.small,
			color: t.color.neutral.txt.default
		} } },
		MuiMenuItem: { styleOverrides: { root: {
			paddingBlockStart: t.measure.spacing.vertical.default,
			paddingBlockEnd: t.measure.spacing.vertical.default,
			paddingInlineStart: t.measure.spacing.horizontal.default,
			paddingInlineEnd: t.measure.spacing.horizontal.default,
			"&:hover": { backgroundColor: t.color.neutral.bg.defaultActive },
			"&:focus": { backgroundColor: t.color.neutral.bg.defaultActive },
			[t.breakpoints.up("md")]: { borderRadius: t.radius.default }
		} } },
		MuiFormHelperText: { styleOverrides: { root: {
			...t.typo.body.small,
			color: t.color.neutral.txt.weak,
			margin: 0
		} } },
		MuiButton: {
			defaultProps: {
				disableRipple: !0,
				disableElevation: !0
			},
			styleOverrides: {
				startIcon: {
					paddingInlineEnd: t.measure.size.xs,
					margin: 0
				},
				text: {
					color: t.color.accent.txt.default,
					borderRadius: 0,
					paddingInline: 0,
					"&:hover, &:focus-visible": {
						color: t.color.accent.txt.defaultActive,
						backgroundColor: "transparent!important"
					}
				},
				outlined: {
					borderColor: t.color.neutral.border.default,
					color: t.color.accent.txt.default,
					backgroundColor: t.color.neutral.bg.default,
					"&:hover": {
						backgroundColor: t.color.neutral.bg.defaultActive,
						color: t.color.accent.txt.defaultActive
					}
				},
				contained: {
					color: t.color.accent.txt.inverted,
					backgroundColor: t.color.accent.bg.default,
					paddingInline: t.measure.size.l,
					":has(.MuiButton-startIcon)": { paddingInlineStart: t.measure.size.m },
					"&:hover": { backgroundColor: t.color.accent.bg.defaultActive },
					"&:focus-visible": {
						outlineWidth: "2px",
						outlineStyle: "solid",
						outlineColor: t.color.accent.bg.strong
					}
				},
				root: {
					minWidth: "auto",
					textTransform: "inherit",
					borderRadius: t.radius.round,
					...t.typo.label.default,
					paddingBlock: "14px"
				}
			}
		},
		MuiAutocomplete: { styleOverrides: { root: { ".MuiInputBase-root.MuiInputBase-root": {
			paddingTop: 0,
			paddingBottom: 0,
			".MuiInputBase-input": {
				paddingTop: t.measure.size.s,
				paddingBottom: t.measure.size.s
			}
		} } } },
		SpaInput: { styleOverrides: { root: {
			backgroundColor: t.color.neutral.bg.delicate,
			borderRadius: t.radius.default,
			paddingInlineStart: t.measure.size.m,
			height: "48px",
			"&.Mui-focused": {
				outlineWidth: "2px",
				outlineStyle: "solid",
				outlineColor: t.color.accent.txt.default
			},
			"&.Mui-error": { backgroundColor: t.color.danger.bg.weak },
			".MuiInputBase-input::placeholder": {
				color: t.color.neutral.txt.weak,
				opacity: 1
			}
		} } },
		SpaInputField: { styleOverrides: { root: {
			paddingBlockStart: t.measure.size.min,
			paddingBlockEnd: t.measure.size.xs,
			paddingInline: t.measure.spacing.horizontal.default,
			gap: t.measure.size.xs
		} } },
		MuiTabs: {
			defaultProps: {
				textColor: "secondary",
				indicatorColor: "secondary"
			},
			styleOverrides: { root: { boxShadow: "0 9px 8px -8px rgba(0, 0, 0, 0.16)" } }
		},
		MuiTab: {
			defaultProps: {
				disableRipple: !0,
				disableFocusRipple: !0,
				disableTouchRipple: !0
			},
			styleOverrides: { root: {
				minHeight: "64px",
				flex: 1,
				textTransform: "none"
			} }
		},
		MuiCard: { styleOverrides: { root: { boxShadow: "0 1px 2px 1px rgba(0, 0, 0, 0.12);" } } },
		MuiChip: { styleOverrides: {
			colorWarning: { backgroundColor: t.color.warning.bg.default },
			colorSuccess: { backgroundColor: t.color.success.bg.default },
			colorError: { backgroundColor: t.color.danger.bg.default },
			colorInfo: {
				backgroundColor: t.color.accent.bg.weak,
				color: t.color.accent.txt.default
			},
			root: {
				...t.typo.body.small,
				borderRadius: t.radius.weak,
				paddingblock: t.measure.size.min
			}
		} },
		SpaStackAdapter: { styleOverrides: { root: { paddingInline: t.measure.spacing.horizontal.default } } },
		SpaDivider: { variants: [{
			props: { variant: "content" },
			style: { paddingInline: t.measure.spacing.horizontal.default }
		}] },
		MuiCheckbox: { styleOverrides: { root: {
			color: t.color.accent.bg.default,
			"&.Mui-checked": { color: t.color.accent.bg.default }
		} } }
	}
}), r = n(t);
//#endregion
export { r as blablacar, n as getBlablacarBaseTheme };

//# sourceMappingURL=index326.js.map